import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraMedicationConsultationSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M24.1709 13.7556C24.1709 13.7556 36.8903 10.7283 38.1006 10.8722C39.2177 11.0048 40.0125 11.3179 40.9296 14.0222C41.8133 16.6278 47.8562 42.8907 47.8673 42.9527C48.5093 46.5514 46.8891 46.8984 45.3523 47.5206C43.8336 48.137 26.8805 52.1758 22.3674 53.2409C21.1849 53.5202 19.8913 53.5569 18.8937 53.2099C18.1044 52.9348 17.2596 52.7077 16.3565 49.765C15.2073 46.0238 10.0398 21.087 10.0398 21.087C10.0398 21.087 9.48543 18.0173 12.5131 17.0877C15.5394 16.158 24.1696 13.7556 24.1696 13.7556H24.1709Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M24.7819 16.215C24.7819 16.215 35.8061 13.5911 36.8538 13.7152C37.8223 13.8295 38.5101 14.1003 39.3062 16.4463C40.0718 18.7048 45.3088 41.465 45.3186 41.5186C45.8743 44.6376 44.471 44.9381 43.1398 45.477C41.824 46.0102 27.1315 49.5115 23.2201 50.4341C22.1961 50.6754 21.0747 50.7078 20.2105 50.4073C19.5255 50.1689 18.7946 49.9728 18.0109 47.4209C17.016 44.1791 12.5363 22.5673 12.5363 22.5673C12.5363 22.5673 12.0569 19.9067 14.6789 19.1012C17.3023 18.2957 24.7819 16.2135 24.7819 16.2135V16.215Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M20.7847 14.0294C20.7847 14.0294 16.2661 14.7686 16.3328 16.1863C16.3981 17.6027 16.4272 19.7766 18.6768 19.596C20.9264 19.4154 33.2345 16.3189 33.9835 15.5741C34.7338 14.8278 34.1377 11.4238 32.9427 11.2207C31.7478 11.0176 28.3644 12.163 28.3644 12.163C28.3644 12.163 26.904 9.28241 24.0625 10.1697C21.221 11.0571 20.7861 14.0308 20.7861 14.0308L20.7847 14.0294Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M50.561 53.9992H37.3497C36.4465 53.9992 35.7129 53.2558 35.7129 52.3374L35.0918 30.8398L53.0912 31.943L52.195 52.3727C52.1756 53.2755 51.4489 53.9978 50.5596 53.9978L50.561 53.9992Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M49.5195 45.9942H41.4368C40.4656 45.9942 39.6777 45.049 39.6777 43.8823V37.5102C39.6777 36.3436 40.4656 35.3984 41.4368 35.3984H49.9377C50.909 35.3984 51.6968 36.3436 51.6968 37.5102L51.28 43.8823C51.28 45.049 50.4921 45.9942 49.5209 45.9942H49.5195Z'
        fill={spotIllustration.primary.fill}
      />
      <Path d='M49.9295 37.9336H41.8496V39.1299H49.9295V37.9336Z' fill={spotIllustration.secondary.fill} />
      <Path d='M49.9295 41.125H41.8496V42.2183H49.9295V41.125Z' fill={spotIllustration.secondary.fill} />
      <Path
        d='M53.3316 29.2346L34.9528 29.1133C34.6541 29.1119 34.4054 29.3461 34.3859 29.6479L34.2025 32.4369C34.1803 32.767 34.4387 33.0477 34.7653 33.0477H53.4358C53.7568 33.0477 54.0125 32.7769 54 32.451L53.8916 29.7834C53.8791 29.4772 53.6331 29.236 53.3316 29.2346Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M52.0477 27.0849L36.5062 26.5164C36.0185 26.498 35.5905 26.8126 35.503 27.2528L34.793 30.8726H53.3927L52.98 27.8678C52.9203 27.4333 52.5256 27.1018 52.0477 27.0849Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
